// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__formItemQuarter___I_SU1 {
  width: 25%;
}

.styles__input___QfWZq {
}

.styles__inputLabelGroup___lXfwN {
  margin-top: 10px;
  margin-bottom: 10px;
}

.styles__inputLabelGroup___lXfwN input {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 10px;
  top: 2px;
  position: relative;
}

.styles__inputLabelGroup___lXfwN label {
  font-size: 14px;
}

.styles__label___giyem {
  text-align: left;
  margin-bottom: 10px;
}

.styles__section___O5R3E {
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Main/ClosingTrackForm/styles.css"],"names":[],"mappings":"AAEA;EAEE,UAAU;AACZ;;AAEA;AAEA;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;AAEA","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\n.formItemQuarter {\n  composes: formItemQuarter from helpers;\n  width: 25%;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.inputLabelGroup {\n  composes: clearfix from helpers;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.inputLabelGroup input {\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-left: 10px;\n  top: 2px;\n  position: relative;\n}\n\n.inputLabelGroup label {\n  font-size: 14px;\n}\n\n.label {\n  composes: label from helpers;\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.section {\n  composes: section from helpers;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"formItemQuarter": `styles__formItemQuarter___I_SU1 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemQuarter"]}`,
	"input": `styles__input___QfWZq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["input"]}`,
	"inputLabelGroup": `styles__inputLabelGroup___lXfwN ${___CSS_LOADER_ICSS_IMPORT_0___.locals["clearfix"]}`,
	"label": `styles__label___giyem ${___CSS_LOADER_ICSS_IMPORT_0___.locals["label"]}`,
	"section": `styles__section___O5R3E ${___CSS_LOADER_ICSS_IMPORT_0___.locals["section"]}`
};
export default ___CSS_LOADER_EXPORT___;
